<template>
  <div>
    <q-table
      :data="pesquisa.perguntas"
      :grid="true"
      :title="pesquisa.nome"
      :rows-per-page-options="[0]"
    >
      <template v-slot:item="props">
        <q-card class="col-lg-6 col-sm-6 col-xs-12 q-mb-sm">
          <q-card-section>
            <EstatisticaPerguntaGrafico
              :idPergunta="props.row._id"
              :key="props.row._id"
              :titulo="props.row.pergunta"
            />
          </q-card-section>
        </q-card>
      </template>
    </q-table>
  </div>
</template>

<script>
import EstatisticaPerguntaGrafico from './EstatisticaPerguntaGrafico'
import { getPesquisa } from '../../services/pesquisa'

export default {
  props: {
    idPesquisa: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      pesquisa: {}
    }
  },
  mounted () {
    this.getPesquisa()
  },
  methods: {
    async getPesquisa () {
      try {
        this.pesquisa = await getPesquisa({ idPesquisa: this.idPesquisa })
      } catch (error) {
        console.error(error)
      }
    }
  },
  components: {
    EstatisticaPerguntaGrafico
  }
}
</script>